function updateFbtDisplay(selectedColor) {
  const groups = document.querySelectorAll('.fbt-color-group');
  const normalizedColor = selectedColor.toLowerCase().trim().replace(/\s+/g, '-');
  let hasMatch = false;

  groups.forEach(group => {
    if (group.classList.contains(`color-${normalizedColor}`)) {
      group.style.display = 'block';
      hasMatch = true;
    } else {
      group.style.display = 'none';
    }
  });

  if (hasMatch) {
    document.body.classList.remove('no-list-fbt');
  } else {
    document.body.classList.add('no-list-fbt');
  }
}

function getSelectedColor() {
  const checkedColorInput = document.querySelector('.variant-Color input[type="radio"]:checked');
  return checkedColorInput?.value?.trim() || '';
}

async function handleAddToCart(fbtButton) {
  const section = fbtButton.closest('.fbt-color-group, .fbt-section');
  if (!section) return;

  const fbtProductMessage = section.querySelector('.fbt-add-message-container');
  if (fbtProductMessage) fbtProductMessage.style.display = 'none';

  fbtButton.setAttribute('aria-disabled', true);
  fbtButton.classList.add('loading');
  fbtButton.innerHTML = '<span class="loading__spinner"></span>Adding products to cart...';

  const selectedProducts = [];
  section.querySelectorAll('.fbt-product-item').forEach(item => {
    const checkbox = item.querySelector('.fbt-checkbox');
    if (checkbox && checkbox.checked && item.dataset.available === 'true') {
      selectedProducts.push({
        id: item.dataset.id,
        quantity: 1
      });
    }
  });

  if (selectedProducts.length >= 1) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: selectedProducts })
      });

      const result = await response.json();
      if (response.ok) {
        const pathParts = window.location.pathname.split('/');
        const currentLocalePrefix = pathParts[1];
        const isLocalePath = /^[a-z]{2}(-[a-z]{2})?$/.test(currentLocalePrefix);
        const cartUrl = isLocalePath ? `/${currentLocalePrefix}/cart` : '/cart';
        window.location.href = cartUrl;
      } else {
        if (response.status === 422) {
          const fbtProductMessage = section.querySelector('.fbt-add-message-container');
          if (fbtProductMessage) {
            fbtProductMessage.textContent = window.productBuyTogetherStrings.errorMessage;
            fbtProductMessage.style.display = 'block';
          }
        } else {
          console.error('Add to cart failed:', result);
        }
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      fbtButton.removeAttribute('aria-disabled');
      fbtButton.classList.remove('loading');
      fbtButton.innerHTML = 'Added Selected to Cart';
    }
  } else {
    fbtButton.removeAttribute('aria-disabled');
    fbtButton.classList.remove('loading');
    fbtButton.innerHTML = 'Add Selected to Cart';
    if (fbtProductMessage) fbtProductMessage.style.display = 'block';
  }
}

function initializeFBT() {
  const customDropdowns = document.querySelectorAll('.fbt-variant-selector.custom-dropdown');
  customDropdowns.forEach(dropdown => {
    const input = dropdown.querySelector('.fbt-variant-input');
    const options = dropdown.querySelector('.dropdown-options');
    const select = dropdown.querySelector('.fbt-variant-select');
    
    if (input && options) {
      input.addEventListener('click', function() {
        dropdown.classList.toggle('open');
        options.classList.toggle('hidden');
      });
      
      options.querySelectorAll('li').forEach(option => {
        option.addEventListener('click', function() {
          const value = this.getAttribute('data-value');
          const text = this.textContent.trim();
          
          input.value = text;
          
          if (select) {
            select.value = value;
            select.dispatchEvent(new Event('change'));
          }
          
          const productItem = dropdown.closest('.fbt-product-item');
          if (productItem) {
            productItem.dataset.id = value;
          }
          
          dropdown.classList.remove('open');
          options.classList.add('hidden');
          
          options.querySelectorAll('li').forEach(opt => {
            opt.classList.remove('selected');
          });
          this.classList.add('selected');
        });
      });
      
      document.addEventListener('click', function(event) {
        if (!dropdown.contains(event.target)) {
          dropdown.classList.remove('open');
          options.classList.add('hidden');
        }
      });
    }
  });

  const variantSelectors = document.querySelectorAll('.fbt-variant-select');
  variantSelectors.forEach(selector => {
    selector.addEventListener('change', function () {
      const productItem = this.closest('.fbt-product-item');
      if (productItem) {
        productItem.dataset.id = this.value;
      }
    });
  });

  const fbtButtons = document.querySelectorAll('.fbt-add-to-cart');
  fbtButtons.forEach(fbtButton => {
    fbtButton.addEventListener('click', () => handleAddToCart(fbtButton));
  });
}

// Initial setup
document.addEventListener('DOMContentLoaded', function() {
  initializeFBT();
  
  // Handle color changes
  document.addEventListener('change', function(event) {
    if (event.target.matches('.variant-Color input[type="radio"]')) {
      updateFbtDisplay(event.target.value.trim());
    }
  });

  // Initial render
  const initialColor = getSelectedColor();
  if (initialColor) {
    updateFbtDisplay(initialColor);
  }
});

window.initializeFBT = initializeFBT;
